module.exports = __webpack_public_path__ + "img/View_All.bb4dd71e.svg";